const SearchFeaturedCategories = class extends HTMLElement {
  constructor() {
    super()

    this.swiper = null
    this.swiperEl = this.querySelector('[data-search-featured-categories-swiper]')
    this.prev = this.querySelector('[data-search-featured-categories-prev]')
    this.next = this.querySelector('[data-search-featured-categories-next]')

    this.options = {
      centerInsufficientSlides: true,
      slidesPerView: '4',
      navigation: {
        nextEl: this.next,
        prevEl: this.prev
      },
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
      spaceBetween: 16,
      breakpoints: {
        1000: {
          slidesPerView: 6
        }
      }
    }
  }

  connectedCallback() {
    this.swiper = new Swiper(this.swiperEl, this.options)
  }
}

if (typeof window.customElements.get('search-featured-categories') === 'undefined') {
  window.customElements.define('search-featured-categories', SearchFeaturedCategories)
}
